import logo from './assets/logo.svg';
import './App.css';
import Hero from './components/Hero/Hero';
import Main from './components/Main/Main';
import Footer from './components/Footer/Footer';

function App() {
    return (
        <div className="App">
            <nav>
                <img src={logo} alt="logo" />
                <ul>
                    <li>
                        <a href="https://reactjs.org" rel="noopener noreferrer"
                        > Features </a>
                    </li>
                    <li>
                        <a href="https://reactjs.org" rel="noopener noreferrer"
                        > Team </a>
                    </li>
                    <li>
                        <a href="https://reactjs.org" rel="noopener noreferrer"
                        > Sign In </a>
                    </li>
                </ul>
            </nav>
            <Hero />
            <Main />
            <Footer />
        </div>
    );
}

export default App;
